import { db } from "../../firebase/firebase";
import revealData from '../../util/revealData';

export const getInvoicesRequest = async (userId) => {
  try {
    let invoices = [];
    let raw = [];
    await db.ref(`invoices/${userId}`).once('value', snap => {
      invoices = snap.val() ? Object.values(snap.val()) : []
    });
    if(invoices.length > 0) {
      await invoices.forEach(async (invoice, index) => {
       await db.ref(`users/${invoice.targetId}`).once('value', async snap => {
         let user = await snap.val();
         let majorId = await user.rol === 'major' ? user.id : userId;
          await db.ref(`products/${majorId}/${invoice.productId}`).once('value', async productsSnap => {
            let product = await {...productsSnap.val()};
            raw.push({
              ...invoice,
              userName: user.name,
              productName: product.name,
              userData: {
                ...user,
                product,
              },
            });
          });
        });
      });
    }
    const invoice = await revealData(raw);
    return await invoice;
  } catch (error) {
    return error;
  }
}

export const addInvoiceRequest = async (form) => {
  try {
    const newRef = await db.ref(`invoices/${form.userId}/`).push();
    await db.ref(`invoices/${form.userId}/${newRef}`).set({...form});
    await db.ref(`invoices/${form.targetId}/${newRef}`).set({...form});
  } catch (error) {
    return error
  }
}
